import React from 'react';
import PropTypes from 'prop-types';
import formatMessage from 'format-message';
import * as searchPaths from '../../constants/search-paths';
import * as paginatedPageSizes from '../../constants/paginated-page-sizes';
import { createFetchResults } from '../../common/util/create-fetch-results';
import { SORTING_ORDER_ASCENDING, SORTING_ORDER_DESCENDING } from '../../constants/search';
import { hasActiveSearch } from '../../common/util/search-query-utils';

// Components
import NoResult from '../common/no-result';
import starUrl from '../../../assets/svg/star-flag.svg';
import Loading from '../common/loading';
import SearchResultsWrapper from './results/wrapper';
import PreviewCardFavorites from '../resources/preview-card-favorites';

// Stores
import ResultsStore from '../../stores/results';

export default class FavoritesHandler extends React.Component {
  static displayName = 'FavoritesHandler'
  static isResultView = true

  static propTypes = {
    session: PropTypes.object,
    favorites: PropTypes.object,
    sortBy: PropTypes.string,
    sortOrder: PropTypes.oneOf([SORTING_ORDER_ASCENDING, SORTING_ORDER_DESCENDING]),
  }

  onCardRender (resource) {
    return (
      <PreviewCardFavorites
        accountSettings={this.props.account && this.props.account.settings}
        allowApprovedContent={this.props.session.allowApprovedContent}
        accountId={this.props.session.accountId}
        available
        resource={resource}
      />
    );
  }

  render () {
    const { session, account, favorites, results } = this.props;

    if (!favorites.listIsLoaded) {
      return (
        <div className="AppHandler--loading">
          <Loading />
        </div>
      );
    }

    const hasFavorites = Boolean(results.total);
    const noResultsMessage = hasFavorites
      ? formatMessage('No Results Found')
      : formatMessage('Currently No Favorites');

    const resultsPerPage = paginatedPageSizes.FAVORITES_PAGE_SIZE;
    const fetchResults = createFetchResults(searchPaths.RESOURCES, resultsPerPage);

    const showSuggestions = hasFavorites && hasActiveSearch(this.props.router.query);

    return (
      <SearchResultsWrapper
        baseParams={{
          onlyFavorites: true
        }}
        fetchResults={fetchResults}
        resultsPerPage={resultsPerPage}
        queryArialLabel={formatMessage(
          'Search My Favorited Resources for course resources by keyword, author, institution, or title'
        )}
        isLoading={ResultsStore.showLoading()}
        emptyMessage={
          <NoResult
            imageUrl={starUrl}
            imageSize={70}
            title={noResultsMessage}
            showSuggestions={showSuggestions}
            message={
              !hasFavorites &&
              formatMessage(
                'Add favorites from Commons by clicking the "Add to Favorites" link in the Resource details page.'
              )
            }
          />
        }
        canShowPublic={
          account.settings.canShowPublic && session.sid && !session.publicOnly
        }
        canToggleLayout={false}
        onCardRender={resource => this.onCardRender(resource)}
        {...this.props}
      />
    );
  }
}
